import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Col, Row } from "reactstrap";
import { H4, P } from "../../AbstractElements";
import ReferralCardBody from "./ReferralCardBody";
import axios from "axios";
import { ServerPath } from "../../Constant";
import ChannelPerformance from './ChannelPerformance';
import TopPerformance from './TopPerformance';
import PerformingVolunteersTable from './PerformingVolunteersTable';

export const NumberOfVolunteers = () => {
    const [count, setCount] = useState("--");

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await axios.get(`${ServerPath}/users/volunteers-count`);
                if (response.data.success) {
                    setCount(response.data.data.total.toLocaleString());
                }
            } catch (error) {
                console.error("Error fetching volunteer count:", error);
            }
        };
        
        fetchCount();
    }, []);

    return (
        <Col md="4" lg="3" className="box-col-4">
            <Card className="sell-card">
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>No. of Volunteers
                                <i className="fa fa-circle"></i>
                            </P>
                            <H4>{count}</H4>
                        </div>
                    </div>
                </CardHeader>
                {/* <NumberOfBlogsCardBody /> */}
                <ReferralCardBody iconType="download" />

            </Card>
        </Col>
    );
};


const ReferralAnalytics = () => {
    const [totalDownloads, setTotalDownloads] = useState("--");
    const [referralDownloads, setReferralDownloads] = useState("--");
    const [activeVolunteers, setActiveVolunteers] = useState("--");  // NEW
    const [referralRate, setReferralRate] = useState("--");

    useEffect(() => {
        const fetchReferralStats = async () => {
            try {
                // Fetch analytics data
                const analyticsResponse = await axios.get(`${ServerPath}/referrals/analytics`);
                console.log('referral analytics response', analyticsResponse.data);
                if (analyticsResponse.data.success) {
                    const data = analyticsResponse.data.data;
                    setTotalDownloads(data.totalDownloads.toLocaleString());
                    setReferralDownloads(data.referralDownloads.toLocaleString());
                    setReferralRate(`${data.referralRate}%`);
                }

                // Fetch active volunteers data
                // const volunteersResponse = await axios.get(`${ServerPath}/referral/active-volunteers`);
                // console.log('active volunteers response', volunteersResponse.data);
                // if (volunteersResponse.data.success) {
                //     const data = volunteersResponse.data.data;
                //     setActiveVolunteers(data.activeVolunteers.toLocaleString());
                // }
            } catch (error) {
                console.error("Error fetching referral stats:", error);
            }
        };

        fetchReferralStats();
    }, []);

    return (
        <Row>
            {/* Total Downloads Card */}
            <Col md="4" lg="3" className="box-col-2">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>
                                    Total Downloads
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{totalDownloads}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="download" />
                </Card>
            </Col>

            {/* Referral Downloads Card */}
            <Col md="4" lg="3" className="box-col-4">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-success" }}>
                                    Referral Downloads
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{referralDownloads}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="share" />
                </Card>
            </Col>

            {/* FIXED: Active Volunteers Card */}
            {/* <Col md="4" lg="3" className="box-col-4">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-warning" }}>
                                    Active Volunteers
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{activeVolunteers}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="users" />
                </Card>
            </Col> */}
            <NumberOfVolunteers/>

            {/* Referral Rate Card */}
            <Col md="4" lg="3" className="box-col-4">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-info" }}>
                                    Referral Rate
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{referralRate}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="percentage" />
                </Card>
            </Col>

            <Row>
                <Col lg="6">
                    <ChannelPerformance />
                </Col>
                <Col lg="6">
                    <TopPerformance />
                </Col>
            </Row>
            <PerformingVolunteersTable/>
        </Row>
    );
};

export default ReferralAnalytics;